import type React from 'react'
import { useEffect, useState } from 'react'
import { PlusIcon } from 'lucide-react'

import { assert } from 'utils/assert'
import * as A from 'shadcdn/ui/alert-dialog'
import { Label } from 'shadcdn/ui/label'
import { Input } from 'shadcdn/ui/input'
import { SoftwareAdminApi } from 'openapi'

export function AddSoftwareButton({ navigateSoftware }: { navigateSoftware: (softwareId: number) => void }) {
  // track ctrl+c click on window
  const [open, setOpen] = useState<boolean>(false)
  const [newSoftwareName, setNewSoftwareName] = useState<string>('')

  useEffect(() => {
    const listener: any = (e: KeyboardEvent) => {
      if (e.key === 'c' && e.ctrlKey) {
        setOpen(true)
      }
    }
    window.addEventListener('keydown', listener)
    return () => {
      window.removeEventListener('keydown', listener)
    }
  }, [])

  async function handleCreateClick(e: React.MouseEvent<HTMLButtonElement>) {
    const name = newSoftwareName.trim()
    if (!name) {
      e.stopPropagation()
      e.preventDefault()
      return false
    }

    const software = await SoftwareAdminApi.create({ requestBody: { name } })
    assert(software?.id, 'software was not saved')
    navigateSoftware(software.id)
  }

  const closeDialog: () => void = () => {
    setOpen(false)
    setNewSoftwareName('')
  }
  return (
    <A.AlertDialog open={open}>
      <A.AlertDialogTrigger className="bg-gray-100 px-3 h-10 py-1 rounded shadow" onClick={() => setOpen(true)}>
        <PlusIcon className="w-4 h-4 mr-1 -mt-1 inline-block" />
        Add Software
      </A.AlertDialogTrigger>
      <A.AlertDialogContent>
        <A.AlertDialogHeader>
          <A.AlertDialogTitle>Create new software</A.AlertDialogTitle>
          <A.AlertDialogDescription>
            <Label>Software name</Label>
            <Input
              value={newSoftwareName}
              autoFocus
              className="focus:ring-white placeholder:text-gray-300"
              onChange={(e) => setNewSoftwareName(e.target.value)}
              // placeholder="Software name"
            />
          </A.AlertDialogDescription>
        </A.AlertDialogHeader>
        <A.AlertDialogFooter>
          <A.AlertDialogCancel onClick={closeDialog}>Cancel</A.AlertDialogCancel>
          <A.AlertDialogAction onClick={handleCreateClick}>Create</A.AlertDialogAction>
        </A.AlertDialogFooter>
      </A.AlertDialogContent>
    </A.AlertDialog>
  )
}
